import CreateCategoryForm from "features/storages/categories/createCategoryForm"
import useTargetStorage from "@/hooks/useTargetStorage"
import { useTranslation } from "react-i18next"
import Section from "components/layout/section"
import SectionHeader from "components/layout/sectionHeader"
import SectionHeaderTitle from "components/layout/sectionHeaderTitle"
import RightSidebar from "components/sidebar/right/RightSidebar"
import PageTitle from "features/navigation/pageTitle"
import { useNavigate } from "react-router-dom"
import useStorages from "hooks/useStorages"
import { paramGuardStorage } from "@/utils/paramGuard"
import { FormStatus } from "@/types"

const CreateCategory = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()

    const { targetStorageDocId: storageId } = useTargetStorage()
    const { 
        storage,
        storageStatus 
    } = useStorages({ storageId })

    // Check params and declare safe ones to use in JSX
    if (!paramGuardStorage({storageId, storage, storageStatus, navigate})) {
        return <></>
    }
    const safeStorageId = storageId!;

    // Return the JSX.
    return (
        <>
            <PageTitle title={t('titleCreateCategory')} />
            <CreateCategoryForm storageId={safeStorageId} />
            <RightSidebar storageId={safeStorageId} />
        </>
    )
}

export default CreateCategory